import { render, staticRenderFns } from "./ExpensiveItem.vue?vue&type=template&id=417db4e4&"
import script from "./ExpensiveItem.vue?vue&type=script&lang=js&"
export * from "./ExpensiveItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports